// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Q63f","question":"styles_question__2wzd3","description":"styles_description__188AK"};